import { createRoot } from 'react-dom/client'
import './index.css'
import './utils.css'
import App from './App.jsx'
import { NavermapsProvider } from 'react-naver-maps'

createRoot(document.getElementById('root')).render(
  <App />
)
